<template>
  <div>
    
    <v-col cols="12">
      <v-row>
        <v-col cols="2">
          <v-select
            dense
            outlined
            :items="listPlatform"
            v-model="platform"
            label="Platform"
            hide-details
            @change="loadData"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-select
            dense
            outlined
            :items="listProdType"
            label="Product Type"
            hide-details
            v-model="prodType"
            @change="filterDataByProdType()"
            v-if="listProdType.length > 0"
          ></v-select>
        </v-col>

        <v-spacer></v-spacer>

        <v-col
          cols="4"
          style="text-align: right"
          v-if="roles.update_vendor_selection"
        >
          <v-btn
            color="primary"
            v-if="platform != '' && prodType != ''"
            @click="dialogImport = !dialogImport"
            style="margin-right: 5px;"
            >Import</v-btn
          >
          <v-btn v-else disabled
          style="margin-right: 5px;">Import</v-btn>

          <v-btn
            color="secondary"
            v-if="platform != '' && prodType != '' && !exporting"
            @click="exportData"
            style="margin-right: 5px;"
            >Export</v-btn
          >
          <v-btn v-else disabled
          style="margin-right: 5px;">Export</v-btn>

          <v-btn
            color="success"
            v-if="platform != '' && showBtn"
            @click="saveData"
            >SAVE</v-btn
          >
          <v-btn v-else disabled>SAVE</v-btn>
        </v-col>

        <v-col cols="12" v-if="informText != ''">
          <v-alert v-if="!alert" type="success" dismissible>{{
            informText
          }}</v-alert>
          <v-alert v-if="alert" type="error" dismissible>{{
            informText
          }}</v-alert>
        </v-col>

        <v-col cols="12">
          <v-data-table
            :items="filterData"
            :headers="headers"
            hide-default-footer
            disable-pagination
            :loading="loading"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  class="shrink mx-4"
                ></v-text-field>
                <v-divider class="mx-4" inset vertical></v-divider></v-toolbar
            ></template>

            <template v-slot:item.selling_price="{ item }">
              <template v-if="item.selling_price"
                >${{ item.selling_price }}</template
              >
            </template>

            <template v-slot:item.standard_shipping_price="{ item }">
              <template v-if="item.standard_shipping_price"
                >${{ item.standard_shipping_price }}</template
              >
            </template>

            <template v-slot:item.expedited_shipping_price="{ item }">
              <template v-if="item.expedited_shipping_price"
                >${{ item.expedited_shipping_price }}</template
              >
            </template>

            <template v-slot:item.standard_processing_fee="{ item }">
              <template v-if="item.standard_processing_fee"
                >${{ item.standard_processing_fee }}</template
              >
            </template>

            <template v-slot:item.expedited_processing_fee="{ item }">
              <template v-if="item.expedited_processing_fee"
                >${{ item.expedited_processing_fee }}</template
              >
            </template>

            <template v-slot:item.basecost_std="{ item }">
              <v-select
                dense
                outlined
                hide-details
                :items="item.vendors"
                :item-text="
                  (obj) => obj.vendor_code + ' ($' + obj.base_cost + ')'
                "
                :item-value="(obj) => obj.vendor_code"
                label="Standard"
                v-model="item.vendor_for_standard"
                @change="calcSTD(item)"
              ></v-select>
            </template>

            <template v-slot:item.basecost_exp="{ item }">
              <v-select
                dense
                outlined
                hide-details
                :items="item.vendors"
                :item-text="
                  (obj) => obj.vendor_code + ' ($' + obj.base_cost + ')'
                "
                :item-value="(obj) => obj.vendor_code"
                label="Expedited"
                v-model="item.vendor_for_expedited"
                @change="calcEXP(item)"
              ></v-select>
            </template>

            <template v-slot:item.margin_std="{ item }">
              ${{ item.margin_std }}
            </template>

            <template v-slot:item.margin_exp="{ item }">
              ${{ item.margin_exp }}
            </template>

            <template v-slot:item.vendor_chosen_by="{ item }">
              <div>{{ item.vendor_chosen_by }}</div>
              <div>{{ item.vendor_chosen_at }}</div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
    
    <BaseDialog :active.sync="dialogImport" dialog_name="Import Vendor Selection">
      <ImportVendor />
    </BaseDialog>
  </div>
</template>

<script>
import axios from "axios";
import Amplify from "aws-amplify";
import moment from "moment-timezone";
import BaseDialog from "../../Common/c-base-dialog.vue";
import ImportVendor from "./c-dialog-import-vendor-selection.vue";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "VendorSelection",

  components: {
    ImportVendor,
    BaseDialog
  },

  data: () => ({
    loading: false,
    search: null,
    vendorData: [],
    filterData: [],
    platform: "",
    prodType: "",
    listPlatform: ["Amazon", "Shopify"],
    headers: [
      { text: "Product Type", value: "product" },
      { text: "Variant", value: "variant_name" },
      { text: "Selling Price", value: "selling_price" },
      { text: "STD Shipping", value: "standard_shipping_price" },
      { text: "EXP Shipping", value: "expedited_shipping_price" },
      { text: "STD Processing Fee", value: "standard_processing_fee" },
      { text: "EXP Processing Fee", value: "expedited_processing_fee" },
      { text: "Basecost (STD)", value: "basecost_std" },
      { text: "Basecost (EXP)", value: "basecost_exp" },
      { text: "Margin (STD)", value: "margin_std" },
      { text: "Margin (EXP)", value: "margin_exp" },
      { text: "Choosen By", value: "vendor_chosen_by" },
    ],
    listProdType: [],
    showBtn: true,
    informText: "",
    alert: null,
    roles: [],
    alertSuccess:false,
    dialogImport: false,
    exporting: false
  }),
  
  created() {
    this.$root.$refs.vendorSelection = this;
  },

  methods: {    
    turnOffDialog(){
      this.dialogImport = false 
    },    
    showAlert() {
      this.alertSuccess = true;
      this.dialogImport = false;
      this.informText =
        "We're currently importing your orders into database. This could take somes minutes to complete. If you'd like, you can close this notification and continue to working.";      
    },
    
    async exportData(){
      this.informText = "";
      this.exporting = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "vendor-selection-exportData"
      );
      console.log("currentSession: ", currentSession.accessToken);
      if (currentSession.accessToken) {
        await fetch(window.domain + "fulfillment/select-vendors/export", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            "platform": this.platform,
            "product_type": this.prodType
          })
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("vendor selection: ", data);
            console.log("data.message: ", data.message);
            
            this.alertSuccess = true;
            this.informText =
            "We're currently preprocessing your data. System will send a file to your email when completed. If you'd like, you can close this notification and continue to working."
            setTimeout(() => {
              this.alertSuccess = false;
            },5000)
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      } else {
        console.log(
          "currentSession vendor-selection-exportData-undefined",
          currentSession
        );
      }
      this.exporting = false;
    },

    async loadData() {
      //this.loading = true;
      this.vendorData = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "quotation-report-loadData"
      );
      this.listProdType = [];
      this.filterData = [];
      this.prodType = "";
      this.alert = null;
      this.informText = "";

      if (currentSession.accessToken) {
        this.userId = currentSession.username;
        await axios
          .get(
            window.domain +
              "/reports/fulfillment?report_type=vendor_selection&platform=" +
              this.platform,
            {
              headers: { Authorization: currentSession.accessToken },
            }
          )
          .then((response) => {
            console.log("response: ", response);
            this.vendorData = response.data.data;
            var temp_prod = new Set();
            for (var a of this.vendorData) {
              a["margin_std"] = 0;
              a["margin_exp"] = 0;

              if (a.vendor_for_standard) this.calcSTD(a);
              if (a.vendor_for_expedited) this.calcEXP(a);

              a.chosen_at = moment(a.chosen_at).format("YYYY-MM-DD HH:MM:SS");
              a.vendor_chosen_at = moment(a.vendor_chosen_at).format(
                "YYYY-MM-DD HH:MM:SS"
              );
              temp_prod.add(a.product);
            }
            this.listProdType = Array.from(temp_prod);
            this.listProdType.unshift("All");
            //this.loading = false;
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      }
    },

    filterDataByProdType() {
      if (this.prodType == "All") {
        this.filterData = this.vendorData;
      } else {
        this.filterData = this.vendorData.filter(
          (t) => t.product == this.prodType
        );
      }
    },

    calcSTD(item) {
      var temp = item.vendors.filter(
        (t) => t.vendor_code == item.vendor_for_standard
      );

      if (temp.length > 0) {
        var base_cost = temp[0].base_cost;
        item.margin_std = parseFloat(
          item.selling_price +
            item.standard_shipping_price -
            item.standard_processing_fee -
            base_cost
        ).toFixed(2);
        this.$forceUpdate();
      }
    },

    calcEXP(item) {
      var temp = item.vendors.filter(
        (t) => t.vendor_code == item.vendor_for_expedited
      );
      if (temp.length > 0) {
        var base_cost = temp[0].base_cost;
        item.margin_exp = parseFloat(
          item.selling_price +
            item.expedited_shipping_price -
            item.expedited_processing_fee -
            base_cost
        ).toFixed(2);
        this.$forceUpdate();
      }
    },

    async saveData() {
      this.showBtn = false;
      var vendor_selection = [];

      for (var a of this.vendorData) {
        var item = {
          platform: this.platform,
          product: a.product,
          variant_id: a.variant_id,
          vendor_for_standard: a.vendor_for_standard,
          vendor_for_expedited: a.vendor_for_expedited,
        };

        vendor_selection.push(item);
      }

      var currentSession = await this.$root.$refs.App.currentSession(
        "quotation-report-saveData"
      );

      if (currentSession.accessToken) {
        this.userId = currentSession.username;
        await axios
          .post(
            window.domain + "fulfillment/select-vendors",
            {
              vendor_selection,
            },

            { headers: { Authorization: currentSession.accessToken } }
          )
          .then((response) => {
            console.log("response: ", response);
            if (response.data.error_message == "") {
              this.alert = false;
              this.informText = "Save Completed!";
            } else {
              this.alert = true;
              this.informText = response.data.error_message;
            }
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      }

      this.showBtn = true;
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("dashboard");
  },
};
</script>

<style lang="scss" scoped>
</style>